<template>
  <v-container fluid>
    <a-tabs v-model="tab" size="small" @change="(v) => changeTab(v)">
      <a-tab-pane :key="0" tab="运单明细"></a-tab-pane>
      <a-tab-pane :key="1" tab="统计结果"></a-tab-pane>
    </a-tabs>
    <template v-if="tab === 0">
      <a-form-model layout="inline">
        <v-row>
          <v-col cols="12" md="4" sm="6">
            <a-form-model-item label="封车日期">
              <a-range-picker v-model="queryForm.times" :locale="locale" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
                :allow-clear="false" />
            </a-form-model-item>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <a-form-model-item label="邮路名称">
              <a-input v-model="queryForm.postroute" placeholder="邮路名称" allow-clear>
              </a-input>
            </a-form-model-item>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <a-form-model-item label="自委办">
              <a-select v-model="queryForm.zwb" sty :options="[
                { value: '自办', label: '自办' },
                { value: '委办', label: '委办' }
              ]" placeholder="请选择" style="width:200px;" allow-clear>
              </a-select>
            </a-form-model-item>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" sm="6">
            <a-form-model-item label="发出邮局">
              <a-input v-model="queryForm.departure" placeholder="发出局" allow-clear>
              </a-input>
            </a-form-model-item>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <a-form-model-item label="接收邮局">
              <a-input v-model="queryForm.destination" placeholder="接收局" allow-clear>
              </a-input>
            </a-form-model-item>
          </v-col>
          <v-col cols="12" md="2" sm="6">
            <a-form-model-item label="车型">
              <a-select v-model="queryForm.vehicle_type" :options="[
                { value: '5', label: '5' },
                { value: '12', label: '12' },
                { value: '30', label: '30' },
                { value: '其他', label: '其他' },
              ]" placeholder="请选择" style="width:100px;" allow-clear>
              </a-select>
            </a-form-model-item>
          </v-col>
          <v-col cols="12" md="2" sm="6">
            <a-form-model-item>
              <a-space>
                <a-button type="primary" @click="getdata()">
                  查询
                </a-button>
              </a-space>
            </a-form-model-item>
          </v-col>
        </v-row>
      </a-form-model>
      <v-card tile class="mt-2">
        <a-table size="small" :columns="headers" :data-source="list" :pagination="false" :locale="{ emptyText: '暂无数据' }"
          :scroll="{ x: width, y: height }" row-key="_id">
          <template slot="title">
            <div class="d-flex justify-space-between">
              <div class="d-flex align-center pl-2">
                <span>共 {{ length }} 页 / {{ count }} 条数据</span>
                <v-menu bottom offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                      {{ limit }}/页
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-for="(item, index) in pages" @click="limit = item.value" :key="index">
                      <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
            </div>
          </template>
        </a-table>
        <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
      </v-card>
    </template>
    <template v-if="tab === 1">
      <a-form-model layout="inline">
        <v-row>
          <v-col cols="12" md="4" sm="6">
            <a-form-model-item label="邮局">
              <a-select v-model="squeryForm.postoffice" :options="postoffices" placeholder="请选择" style="width:150px;"
                allow-clear>
              </a-select>
            </a-form-model-item>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <a-form-model-item label="线路">
              <a-input v-model="squeryForm.postroute" placeholder="线路" allow-clear>
              </a-input>
            </a-form-model-item>
          </v-col>
          <v-col cols="12" md="2" sm="6">
            <a-form-model-item>
              <a-space>
                <a-button type="primary" @click="getstatistics()">
                  查询
                </a-button>
              </a-space>
            </a-form-model-item>
          </v-col>
        </v-row>
      </a-form-model>
      <v-card tile class="mt-2">
        <a-table size="small" :columns="sheaders" :data-source="slist" :pagination="false"
          :locale="{ emptyText: '暂无数据' }" :scroll="{ x: swidth, y: height + 150 }" row-key="_id">

        </a-table>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import _ from "underscore";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { mapState } from "vuex";
export default {
  name: "WaybillHis",
  data() {
    return {
      tab: 0,
      locale,
      pages: [
        { text: '20/页', value: 20 },
        { text: '50/页', value: 50 },
        { text: '100/页', value: 100 },
        // { text: '200/页', value: 200 },
      ],
      queryForm: {
        times: [null, null],
        postroute: "",
        departure: "",
        destination: "",
        zwb: undefined,
        vehicle_type: undefined,
      },
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      headers: [
        { title: "发出省", dataIndex: "departure_province", scopedSlots: { customRender: "departure_province" }, width: 120, align: "center" },
        { title: "发出局", dataIndex: "departure_postoffice", scopedSlots: { customRender: "departure_postoffice" }, width: 120, align: "center" },
        { title: "派押省", dataIndex: "dispatch_province", scopedSlots: { customRender: "dispatch_province" }, width: 120, align: "center" },
        { title: "派押局", dataIndex: "dispatch_postoffice", scopedSlots: { customRender: "dispatch_postoffice" }, width: 120, align: "center" },
        { title: "邮路代码", dataIndex: "postroute_code", scopedSlots: { customRender: "postroute_code" }, width: 120, align: "center" },
        { title: "自委办", dataIndex: "zwb", scopedSlots: { customRender: "zwb" }, width: 120, align: "center" },
        { title: "发出局", dataIndex: "departure", scopedSlots: { customRender: "departure" }, width: 120, align: "center" },
        { title: "发出地市", dataIndex: "departure_city", scopedSlots: { customRender: "departure_city" }, width: 120, align: "center" },
        { title: "接收局", dataIndex: "destination", scopedSlots: { customRender: "destination" }, width: 120, align: "center" },
        { title: "邮路名称", dataIndex: "postroute", scopedSlots: { customRender: "postroute" }, width: 120, align: "center" },
        { title: "封车时间", dataIndex: "block_time", scopedSlots: { customRender: "block_time" }, width: 120, align: "center" },
        { title: "时间点", dataIndex: "sjd", scopedSlots: { customRender: "sjd" }, width: 120, align: "center" },
        { title: "GPS入围栏时间", dataIndex: "in_time", scopedSlots: { customRender: "in_time" }, width: 120, align: "center" },
        { title: "类型", dataIndex: "lx", scopedSlots: { customRender: "lx" }, width: 120, align: "center" },
        { title: "路单流水号", dataIndex: "serial_no", scopedSlots: { customRender: "serial_no" }, width: 120, align: "center" },
        { title: "派车单号", dataIndex: "dispatch_no", scopedSlots: { customRender: "dispatch_no" }, width: 120, align: "center" },
        { title: "车牌号", dataIndex: "vehicle_number", scopedSlots: { customRender: "vehicle_number" }, width: 120, align: "center" },
        { title: "车辆类型", dataIndex: "cllx", scopedSlots: { customRender: "cllx" }, width: 120, align: "center" },
        { title: "车型", dataIndex: "vehicle_type", scopedSlots: { customRender: "vehicle_type" }, width: 120, align: "center" },
        { title: "车辆承运单位", dataIndex: "dispatch_response_corp", scopedSlots: { customRender: "dispatch_response_corp" }, width: 120, align: "center" },
        { title: "运力类型", dataIndex: "yllx", scopedSlots: { customRender: "yllx" }, width: 120, align: "center" },
        { title: "车厢车牌", dataIndex: "vehicle_gnumber", scopedSlots: { customRender: "vehicle_gnumber" }, width: 120, align: "center" },
        { title: "车辆容积(m³)", dataIndex: "vehicle_volume", scopedSlots: { customRender: "vehicle_volume" }, width: 120, align: "center" },
        { title: "车辆吨位(T)", dataIndex: "vehicle_weight", scopedSlots: { customRender: "vehicle_weight" }, width: 120, align: "center" },
        { title: "运输量", dataIndex: "transport_amount", scopedSlots: { customRender: "transport_amount" }, width: 120, align: "center" },
        { title: "总包数量(袋)", dataIndex: "zbsl_d", scopedSlots: { customRender: "zbsl_d" }, width: 120, align: "center" },
        { title: "邮件数量(件)", dataIndex: "yjsl_j", scopedSlots: { customRender: "yjsl_j" }, width: 120, align: "center" },
        { title: "重量(KG)", dataIndex: "weight_kg", scopedSlots: { customRender: "weight_kg" }, width: 120, align: "center" },
        { title: "邮路级别", dataIndex: "postroutelevel", scopedSlots: { customRender: "postroutelevel" }, width: 120, align: "center" },
        { title: "邮路种类", dataIndex: "ylzl", scopedSlots: { customRender: "ylzl" }, width: 120, align: "center" },
        { title: "邮路性质", dataIndex: "ylxz", scopedSlots: { customRender: "ylxz" }, width: 120, align: "center" },
        { title: "邮路吨位", dataIndex: "yldw", scopedSlots: { customRender: "yldw" }, width: 120, align: "center" },
        { title: "邮路里程(公里)", dataIndex: "postroute_km", scopedSlots: { customRender: "postroute_km" }, width: 120, align: "center" },
        { title: "GPS里程(公里)", dataIndex: "gps_km", scopedSlots: { customRender: "gps_km" }, width: 120, align: "center" },
        { title: "计划运行时长", dataIndex: "plan_duration", scopedSlots: { customRender: "plan_duration" }, width: 120, align: "center" },
        { title: "实际运行时长", dataIndex: "real_duration", scopedSlots: { customRender: "real_duration" }, width: 120, align: "center" },
        { title: "接收省", dataIndex: "destination_province", scopedSlots: { customRender: "destination_province" }, width: 120, align: "center" },
        { title: "GPS出围栏时间", dataIndex: "out_time", scopedSlots: { customRender: "out_time" }, width: 120, align: "center" },
        { title: "入局时间", dataIndex: "scan_time", scopedSlots: { customRender: "scan_time" }, width: 120, align: "center" },
        { title: "解车时间", dataIndex: "unblock_time", scopedSlots: { customRender: "unblock_time" }, width: 120, align: "center" },
        { title: "准点情况", dataIndex: "zdqk", scopedSlots: { customRender: "zdqk" }, width: 120, align: "center" },
        { title: "派班性质", dataIndex: "shift_order", scopedSlots: { customRender: "shift_order" }, width: 120, align: "center" },
      ],
      squeryForm: {
        postoffice: undefined,
        postroute: "",
      },
      postoffices: [],
      slist: [],
      sheaders: [],
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    swidth() {
      return _.reduce(this.sheaders, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  mounted() {
    this.height = window.innerHeight - 400;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 400;
    };
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
    this.queryForm = {
      times: [null, null],
      postroute: "",
      departure: "",
      destination: "",
    }
    this.getdata();
  },
  methods: {
    changeTab(v) {
      console.log('changeTab', v);
      this.tab = v;
      if (v === 0) {
        this.getdata();
      }
      else if (v === 1) {
        this.getstatistics();
      }
    },
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/waybillhis/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        // console.log(res);
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    getstatistics() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/waybillhis/statistics", { ...this.squeryForm }).then((res) => {
        this.$toast.clear();
        // console.log(res);
        if (res.code === 0) {
          this.slist = res.data.list;
          this.sheaders = res.data.headers;
          this.postoffices = res.data.postoffices;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: unset;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>